import React from 'react';
import IconWrapper from '../../../IconWrapper';
const LogoutIconMedium = (props) => (React.createElement(IconWrapper, { ...props },
    React.createElement("path", { d: "M11.5 3a.5.5 0 0 0 0-1h-7a.5.5 0 0 0-.5.5v19a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 0-1H5V3h6.5Z" }),
    React.createElement("path", { d: "M15.636 7.15a.5.5 0 0 1 .706-.022l4.793 4.5a.499.499 0 0 1 .158.366.499.499 0 0 1-.158.367l-4.793 4.5a.5.5 0 1 1-.684-.73l3.874-3.637H9.5a.5.5 0 1 1 0-1h10.032l-3.874-3.637a.5.5 0 0 1-.022-.707Z" })));
export default LogoutIconMedium;
//# sourceMappingURL=LogoutIconMedium.js.map